import * as React from 'react';
import { Tooltip, Typography } from '@mui/material';
import { FieldProps } from 'react-admin';
import { useRecordContext } from 'react-admin';
import { Answer } from '../domain';


const shortenUuid = (value: string) => value.slice(0, 8);

// Display shortened version of uuid (truncates at first `-`, which is probably
// unique enough for us)
export const UuidField: React.FC<FieldProps> = ({ source = '' }) => {
  const record = useRecordContext();
  return (
  <Tooltip title={record?.[source] || ''}>
    <Typography variant="body2">
      {shortenUuid(record?.[source] || '')}
    </Typography>
  </Tooltip>
  );
};

// Link to answer view filtered by participant
export const LinkToParticipantField: React.FC<FieldProps<Answer>> = ({ source = '' }) => {
  const record = useRecordContext();
  if (!record) return null;
  const thisLink = `#/answer?displayedFilters=%7B"participant_id"%3Atrue%7D&filter=%7B"participant_id"%3A"${record?.[source]}"%7D&order=DESC&page=1&perPage=100&sort=created_at`;
  return (<span><a href={thisLink}>{shortenUuid(record?.[source] || '')}</a></span>);    
};


// Display simple audio player
export const AudioField: React.FC<FieldProps> = ({ source = '' }) => {
  const record = useRecordContext();
  return (
  
  <span>
    <audio src={record?.[source]} controls />
  </span>
  );
};
